import React from "react";
import PortfolioProps from "../components/WorkPages/PortfolioItem";
import ResumePDF from "../documents/Jessica_Wan_Resume_2024.pdf";

type PortfolioInfo = {
  title: string;
  desc: string;
  link: string | null;
  linkLabel: string | null;
  role: string | null;
  tags: string[];
  image: string[];
  bullets: [string, string][];
  year: number;
};

const anim_portfolio: PortfolioInfo[] = [
  {
    title: "Character Gameplay Animation",
    desc: "Created game-engine ready cyclable action sequences on custom 3D character.",
    link: "https://drive.google.com/file/d/1pyHh6wgyzuIUd5MXcSULmXMmQqjn1es9/view?usp=sharing",
    linkLabel: "Demo Video",
    role: null,
    tags: ["maya", "game dev", "unreal"],
    image: ["", "/images/fight_seq.mp4"],
    bullets: [],
    year: 2025,
  },
  {
    title: "Bear Necessiteas",
    desc: "3D-animated short film from storyline development to character modeling, rigging, shading, and animation using Autodesk Maya.",
    link: "https://drive.google.com/file/d/1W5768CUB89XjAzyr1c7GPbWowBUdn6EY/view",
    linkLabel: "Demo Video",
    role: null,
    tags: ["maya", "game dev"],
    image: [
      "/images/animation_demo.png",
      "https://player.vimeo.com/video/1048135105",
    ],
    bullets: [],
    year: 2024,
  },
  {
    title: "Character Modelling",
    desc: "Custom character design, modeling, rigging, and walk animation in Maya.",
    link: "https://drive.google.com/file/d/1pyHh6wgyzuIUd5MXcSULmXMmQqjn1es9/view?usp=sharing",
    linkLabel: "Demo Video",
    role: null,
    tags: ["maya", "game dev"],
    image: ["", "/images/char_demo.mp4"],
    bullets: [],
    year: 2025,
  },
  {
    title: "Realistic Modeling + Shading",
    desc: "Modeling and shading to recreate figurine object with Maya.",
    link: "https://drive.google.com/file/d/1pyHh6wgyzuIUd5MXcSULmXMmQqjn1es9/view?usp=sharing",
    linkLabel: "Demo Video",
    role: null,
    tags: ["maya", "game dev"],
    image: ["/images/shade_demo.gif"],
    bullets: [],
    year: 2024,
  },
];

export { anim_portfolio };
